export interface ILoginMetaData {
  userName: string;
  password: string;
}

export interface IForgetPasswordMeteData {
  userName: string;
  otp: string;
}

export interface IAuthStore {
  loginSide?: boolean;
  whiteLogo?: boolean;
  setLoginSide: (state: boolean) => void;
  setWhiteLogo: (state: boolean) => void;
  resetState: () => void;
  step: IAuthStepEnum;
  setStep: (state: IAuthStepEnum) => void;
  finalStep: IAuthStepEnum;
  setFinalStep: (state: IAuthStepEnum) => void;
  changeType: () => void;
  setChangeType: (func: () => void) => void;
  loginMetaData: ILoginMetaData;
  setLoginMetaData: (data: ILoginMetaData) => void;
  forgetPasswordMeteData: IForgetPasswordMeteData;
  setForgetPasswordMeteData: (data: IForgetPasswordMeteData) => void;
}

export enum IAuthStepEnum {
  LOGIN = "login",
  REGISTER_PATIENT = "register-patient",
  REGISTER_DOCTOR = "register-doctor",
  REGISTER_STAFF = "register-staff",
  FORGET_PASSWORD = "forget-password",
  CHECK_LOGIN_VERIFICATION_EMAIL = 0,
  CHECK_LOGIN_VERIFICATION_PHONE,
  CHECK_FORGET_PASSWORD_VERIFICATION_EMAIL,
  CHECK_FORGET_PASSWORD_VERIFICATION_PHONE,
  CREATE_NEW_PASSWORD,
}
